import { render, staticRenderFns } from "./orderfinding.vue?vue&type=template&id=20e4c44a&"
import script from "./orderfinding.vue?vue&type=script&lang=js&"
export * from "./orderfinding.vue?vue&type=script&lang=js&"
import style0 from "./orderfinding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports